import React from 'react';
import './FormComponent.css'
import { motion } from "framer-motion";
import { InputText } from "primereact/inputtext";
import { useState, useRef } from 'react';
import * as Yup from "yup";
import { Dropdown } from 'primereact/dropdown';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useFormik } from 'formik';

import { Calendar } from 'primereact/calendar';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { MultiSelect } from 'primereact/multiselect';
import { SelectButton } from 'primereact/selectbutton';
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Col, Row } from 'react-bootstrap';

import { Checkbox } from 'primereact/checkbox';
const desiredTimezone = 'Asia/Colombo';

const FormComponent = ({ type, ...rest }) => {


    switch (type) {
        case "input-number":
            return (
                <div className="p-fluid my-3" style={{ height: "9vh" }} >
                    <span className="p-float-label " style={{ width: "100%", height: "6vh", }}>
                        <InputText type='text' id={rest.id} name={rest.name} value={rest.value} onChange={rest.onChange} style={rest.style} className={`${rest.errors ? 'p-invalid' : ""}`} keyfilter="int" />
                        <label htmlFor="fullName" > {rest.label}</label>

                        <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                    </span>

                </div>

            );
            case "input-number-group":
                return (
                    <div className=" d-flex mx-2  p-fluid my-3" style={{ height: "9vh" }} >
                        <span className="p-float-label " style={{ width: "100%", height: "6vh", }}>
                            <InputText type='text' id={rest.id} name={rest.name} value={rest.value} onChange={rest.onChange} style={rest.style} className={`${rest.errors ? 'p-invalid' : ""}`} keyfilter="int" />
                            <label htmlFor="fullName" > {rest.label}</label>
    
                            <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                        </span>
                        {rest.endContent}
    
                    </div>
    
                );
        case "input-alphanum":
            return (
                <div className=" mx-2  p-fluid my-3" style={{ height: "9vh" }} >
                    <span className="p-float-label " style={{ width: "100%", height: "6vh", }}>
                        <InputText type='text' id={rest.id} name={rest.name} value={rest.value} onChange={rest.onChange} style={rest.style} className={`${rest.errors ? 'p-invalid' : ""}`} keyfilter="alphanum"  />
                        <label htmlFor="fullName" > {rest.label}</label>

                        <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                    </span>

                </div>

            );
        case "input-alpha":
            return (
                <div className=" mx-2  p-fluid my-3" style={{ height: "9vh" }} >
                    <span className="p-float-label " style={{ width: "100%", height: "6vh", }}>
                        <InputText type='text' id={rest.id} name={rest.name} value={rest.value} onChange={rest.onChange} style={rest.style} className={`${rest.errors ? 'p-invalid' : ""}`} keyfilter="alpha" />
                        <label htmlFor="fullName" > {rest.label}</label>

                        <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                    </span>

                </div>

            );
            case "input-alpha-group":
                return (
                    <div className=" mx-2  p-fluid my-3 d-flex" style={{ height: "9vh" }} >
                        <span className="p-float-label " style={{ width: "100%", height: "6vh", }}>
                            <InputText type='text' id={rest.id} name={rest.name} value={rest.value} onChange={rest.onChange} style={rest.style} className={`${rest.errors ? 'p-invalid' : ""}`} keyfilter="alphanum"  />
                            <label htmlFor="fullName" > {rest.label}</label>
    
                            <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                        </span>
                         {rest.endContent}
                    </div>
    
                );
        case "input-address":
            return (
                <div className=" mx-2  p-fluid my-3" style={{ height: "9vh" }} >
                    <span className="p-float-label " style={{ width: "100%", height: "6vh", }}>
                        <InputText type='text' id={rest.id} name={rest.name} value={rest.value} onChange={rest.onChange} style={rest.style} className={`${rest.errors ? 'p-invalid' : ""}`} i/>
                        <label htmlFor="fullName" > {rest.label}</label>

                        <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                    </span>

                </div>

            );
        case "input-email":
            return (
                <div className="p-card-con mx-2  p-fluid my-2" style={{ height: "9vh" }} >
                    <span className=" p-float-label " style={{ width: "100%", height: "6vh", }}>
                        <InputText type='text' keyfilter="email" id={rest.id} name={rest.name} value={rest.value} onChange={rest.onChange} style={rest.style} className={`${rest.errors ? 'p-invalid' : ""}`} />
                        <label htmlFor="fullName" > {rest.label}</label>

                        <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                    </span>

                </div>

            );
        case "search-dropdown":
            return (
                <div className={` d-flex justify-content-center flex-column mx-2 my-2 ${rest.className}`} style={rest.style} id={rest.id}>
                    <Dropdown value={rest.value} name={rest.name} onChange={rest.onChange} options={rest.options} optionLabel="name" placeholder={rest.placeholder} style={{ height: "6vh", width: "100%" }}
                        filter className="" />
                    <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>

                </div>





            );
        case "label-dropdown":
            return (
                <div className="  d-flex flex-column  justify-content-center mx-2 my-4 " style={{ height: "9vh", width: "100%" }}>
                    <span className="p-float-label " style={{ height: "6vh", width: "100%" }}>
                        <Dropdown inputId="dd-city" value={rest.value} name={rest.name} onChange={rest.onChange} options={rest.options} optionLabel="name" className="w-full md:w-14rem" style={{ width: "100%", height: "6vh" }} />
                        <label htmlFor="dd-city">{rest.placeholder}</label>

                    </span>
                    <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>

                </div>
            );
        case "date-float":
            return (
                <div className=''>
                    <label htmlFor="birth_date" className='ms-2'>{rest.label}</label>
                    <div className=" d-flex flex-column justify-content-center mx-2 " style={{ height: "8vh" }}>

                        <Calendar inputId="birth_date" value={rest.value} onChange={rest.onChange} name={rest.name} style={{ height: "5vh", width: "100%" }} showIcon />

                        <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                    </div>
                </div>

            )

        case "check-box":

            return (
                <div className="d-flex justify-content-center">
                    <Checkbox onChange={rest.onchange} checked={rest.checked} name={rest.name}></Checkbox>

                </div>
            )
        case "text-area":
            return (
                <div className="flex justify-content-center ">
                    <span className="p-float-label my-2" style={{ height: "20dvh", width: "100%" }}>
                        <InputTextarea id="description" value={rest.value} onChange={rest.onChange} placeholder={rest.placeholder} rows={5} cols={30} style={{ marginTop:"15px",height: "20dvh", resize: "none", width: "100%" }} name={rest.name} />
                        <label htmlFor="description">{rest.label}</label>
                        <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>


                    </span>

                </div>

            )
        case "date-picker":

            return (
                <div className="d-flex justify-content-center align-items-center " style={{ height: "100%" }}>
                    <div className="d-flex flex-column" style={{ width: "100%" }}>
                        <span className="p-float-label d-flex  justify-content-center align-items-center flex-column" style={{ height: "8vh", width: "100%" }}>
                            <Calendar
                                //readOnlyInput
                                showIcon={true}
                                name={rest.name}
                                value={
                                    (() => {
                                        if (rest.value) {
                                            const formattedDate = rest.value;
                                            const [day, month, year] = formattedDate.split('/');
                                            return new Date(year, month - 1, day);
                                        } else {
                                            return new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
                                        }
                                    })()
                                }
                                onChange={(e) => {
                                    const selectedDate = e.value;

                                    if(selectedDate){

                                    if (selectedDate > new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }))) {
                                      
                                        rest.setFieldValue(rest.name, new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone })).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                        }));
                                    } else {
                                        
                                        const formattedDate = `${selectedDate.getDate()}/${selectedDate.getMonth() + 1}/${selectedDate.getFullYear()}`;
                                        rest.setFieldValue(rest.name, formattedDate);
                                    }
                                }
                                }}
                                style={{ height: "8vh", width: "100%" }}
                                dateFormat="dd/mm/yy"
                            />

                            <label htmlFor="birth_date" style={{paddingBottom:"2px",marginTop:"15px"}}>{rest.label}</label>

                        </span>
                        <p><small className="p-error">{rest.errors}</small>  <small className="p-error"></small></p>
                    </div>
                </div>
            );


    }

}

export default FormComponent
